import { useNavigate } from 'react-router-dom';
import { Alert, Button, Form, Input, Typography } from 'antd';
import { useCreateWorkspace } from '@presentation/hooks/useWorkspaces';
import { ValidationError } from '@core/errors/AppError';
import { setAntdFormErrors } from '@shared/utils/formErrors';
import { paths } from '@app/routes/paths';

interface CreateWorkspaceFormValues {
  name: string;
  description?: string;
}

export const CreateWorkspacePage = () => {
  const navigate = useNavigate();
  const createWorkspace = useCreateWorkspace();
  const [form] = Form.useForm<CreateWorkspaceFormValues>();

  const handleFinish = (values: CreateWorkspaceFormValues) => {
    createWorkspace.mutate(values, {
      onSuccess: (workspace) => navigate(paths.workspaceSettings(workspace.id), { replace: true }),
      onError: (error) => {
        if (error instanceof ValidationError) {
          setAntdFormErrors(form, error.errors);
        }
      },
    });
  };

  const generalError =
    createWorkspace.error && !(createWorkspace.error instanceof ValidationError)
      ? createWorkspace.error.message
      : null;

  return (
    <div className="mx-auto max-w-lg px-6 py-10">
      <Typography.Title level={3} className="!mb-6">
        New workspace
      </Typography.Title>

      <Form form={form} layout="vertical" onFinish={handleFinish}>
        <Form.Item
          name="name"
          label="Name"
          rules={[{ required: true, message: 'Name is required' }]}
        >
          <Input autoFocus />
        </Form.Item>

        <Form.Item name="description" label="Description">
          <Input.TextArea rows={3} />
        </Form.Item>

        {generalError && <Alert type="error" showIcon title={generalError} className="mb-4" />}

        <div className="flex gap-2">
          <Button type="primary" htmlType="submit" loading={createWorkspace.isPending}>
            Create workspace
          </Button>
          <Button onClick={() => navigate(paths.workspaces)}>Cancel</Button>
        </div>
      </Form>
    </div>
  );
};
